import { Component, OnDestroy, OnInit } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { API } from '@config/constants/api.constant';
import { UtilitiesService } from '@services/utilities.service';
import { BehaviorSubject } from 'rxjs';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { getDistributorTableColumns } from '../../../distributor.data';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-registration',
  styleUrls: ['./registration.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_PENDING_REGISTRATION"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailPending"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/pending/registration/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class RegistrationComponent implements OnInit, OnDestroy {
  tableColumns: TableColumn[] = getDistributorTableColumns('pending');
  privilegeDetailPending: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailPending.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_MENUNGGU', 'TAB_LIST_REGISTRATION_REQUEST', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailPending.value, this.tableColumns);
  }

  onTotalCount = (e: number) => RegistrationComponent.totalCount.next(e);

  ngOnDestroy() {}

  protected readonly API = API;
}
